import app from 'flarum/forum/app';
function counterEnabled() {
  return app.forum.attribute('magicread_enable_counter') !== false;
}
function getTextarea(ctx) {
  const legacy = ctx?.attrs?.composer?.editor?.el;
  if (legacy && document.body.contains(legacy)) return legacy;
  const composer = document.querySelector('.Composer:not(.minimized)');
  return composer?.querySelector('.TextEditor textarea') || null;
}
function createCounterLi() {
  const li = document.createElement('li');
  li.className = 'item-magicread-counter';
  const span = document.createElement('span');
  span.className = 'MagicRead-CharCounter';
  span.textContent = '0';
  span.setAttribute('aria-live', 'polite');
  li.appendChild(span);
  return {
    li,
    span
  };
}
function mountCounterLeft(ctx) {
  const ta = getTextarea(ctx);
  if (!ta) return null;
  const composer = ta.closest('.Composer');
  if (!composer) return null;
  const controls = composer.querySelector('.Composer-controls');
  if (!controls) return null;
  let li = controls.querySelector('li.item-magicread-counter');
  let span = null;
  if (li) {
    span = li.querySelector('.MagicRead-CharCounter');
  } else {
    const nodes = createCounterLi();
    li = nodes.li;
    span = nodes.span;
    controls.insertAdjacentElement('afterbegin', li);
  }
  return span;
}
export function bindCounter(ctx) {
  if (!counterEnabled()) return;
  const ta = getTextarea(ctx);
  if (!ta) return;
  const counter = mountCounterLeft(ctx);
  if (!counter) return;
  if (ctx.magicReadTa === ta && typeof ctx.magicReadUpdate === 'function') {
    ctx.magicReadUpdate();
    return;
  }
  if (ctx.magicReadTa && ctx.magicReadUpdate) {
    ctx.magicReadTa.removeEventListener('input', ctx.magicReadUpdate);
  }
  const update = () => {
    counter.textContent = String(ta.value.length);
  };
  ta.addEventListener('input', update);
  update();
  ctx.magicReadTa = ta;
  ctx.magicReadCounterEl = counter;
  ctx.magicReadUpdate = update;
}
export function destroyCounter(ctx) {
  if (ctx.magicReadTa && ctx.magicReadUpdate) {
    ctx.magicReadTa.removeEventListener('input', ctx.magicReadUpdate);
  }
}
flarum.reg.add('forumaker-magicread', 'forum/components/counter', { bindCounter: bindCounter,destroyCounter: destroyCounter, });